import type { FunctionComponent } from 'react';

import type { IHeadings } from '../../../shared/components/content-markdown/content-markdown';
import { FormattedMessage } from '../../../shared/components/formatted-message/formatted-message';
import { createClassName, createStyleHelper } from '../../../shared/utils/class-names';

import styles from './table-of-content.module.scss';

const style = createStyleHelper(styles, 'table-of-content');

export interface ITableOfContentsProps {
    className?: string;
    headings: IHeadings[];
}

export const TableOfContents: FunctionComponent<ITableOfContentsProps> = ({
    className,
    headings,
}) => {
    return (
        <div className={createClassName([className, style()])}>
            <h1 className={style('heading')}>
                <FormattedMessage
                    id="documents.table-of-content"
                    defaultMessage="Table of contents"
                />
            </h1>
            <ol className={style('list')}>
                {headings.map((item, id) => (
                    <li key={id}>
                        <a className={style('link')} href={'#' + item.id}>
                            {item.title}
                        </a>
                    </li>
                ))}
            </ol>
        </div>
    );
};
